<template>
  <div>
    <!-- <el-dropdown trigger="click" class="international" @command="handle"> -->
      <!-- <div class="user-info">
        <img src="@/assets/img/user.png" alt="">
        <span class="user-name">{{ info.userName }}</span>
      </div> -->
      <!-- <el-dropdown-menu slot="dropdown"> -->
        <!-- <el-dropdown-item command="password">
          modifyPasswords
        </el-dropdown-item>
        <el-dropdown-item command="logout">
          logout
        </el-dropdown-item> -->
      <!-- </el-dropdown-menu> -->
    <!-- </el-dropdown> -->
  </div>
</template>

<script>
import {logout} from '@/api/login'
export default {
  data() {
    return {
      info: {},
      title: 'Modify Passwords',
      visible: false
    }
  },
  methods: {
    async handle(type) {  
        if (res.data) {
          sessionStorage.clear()
        } else {
        this.visible = true
      }
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.user-info {
  display: flex;
  color: rgba(255, 255, 255, 0.5);
  img {
    width: 40px;
    vertical-align: middle;
  }
  .user-name {
    margin-left: 5px;
    line-height: 40px;
  }
}
</style>
